import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Text, Icon } from '@qga/roo-ui/components';
import AppLink from 'components/AppLink';

const StyledBackLink = styled(AppLink)`
  color: ${themeGet('colors.greys.steel')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
`;

type Props = {
  to: string;
  label: string;
  phoneLabel: string;
  onClick?: () => void;
};

const BackLink = ({ to, label, phoneLabel, onClick, ...rest }: Props) => {
  const phoneLabelText = phoneLabel || 'Back to results';

  return (
    <StyledBackLink href={undefined} target="" {...rest} to={to} onClick={onClick} data-testid="back-link">
      <Icon name="chevronLeft" color="greys.charcoal" size={24} mr={2} title="Back to results" />
      <Text fontSize="base" display={['none', 'block']} data-testid="not-phone-label">
        {label}
      </Text>
      <Text fontSize="base" display={['block', 'none']} data-testid="phone-label">
        {phoneLabelText}
      </Text>
    </StyledBackLink>
  );
};

export default BackLink;
